// Which list the desk's Lists screen opens (a4-02). Pure and import-free so
// the Worker's suite — the only one `npm run check` gates on — can load it.
//
// Two values used to be one: `kiez-desk-list` in localStorage was both "the
// list last open on this machine" and "the list on screen", so a link to
// `#/lists/<id>` opened whatever was open last while the hash went on naming
// the other one. The route now says what is on screen; the stored id only
// answers a bare `#/lists`.

/** The virtual list: saved events, not a `lists` row. The desk draws it as a
 *  pane under this id. The phone has no screen for it — the Lists index *is*
 *  the Shortlist — so `#/lists/shortlist` is an alias there that rewrites to
 *  `#/lists`: a link copied from the desk still lands somewhere sensible. */
export const SAVED_LIST = 'shortlist'

export interface DeskListPick {
  /** The id to draw: a list id, `SAVED_LIST`, or null for none yet. */
  open: string | null
  /** The route named something that is not there; say `#/lists` instead. */
  rewrite: boolean
  /** The route named something that is; store it as the one last open. */
  remember: boolean
}

/**
 * `routeId` is the hash's second segment; `remembered` is the stored id;
 * `activeIds` are the unarchived lists in nav order; `loaded` is false until
 * the lists query has rows to judge the route by. An id cannot be called
 * unknown before then — that would rewrite a good link on every cold load.
 */
export function pickDeskList(
  routeId: string | null,
  remembered: string | null,
  activeIds: readonly string[],
  loaded: boolean,
): DeskListPick {
  const known = (id: string) => id === SAVED_LIST || activeIds.includes(id)
  if (routeId && (known(routeId) || !loaded)) {
    return { open: routeId, rewrite: false, remember: loaded || routeId === SAVED_LIST }
  }
  const fallback = remembered && known(remembered) ? remembered : activeIds[0] ?? null
  return { open: fallback, rewrite: !!routeId, remember: false }
}
